import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { UserViewRoutingModule } from './user-view-routing.module';
import { MatTableModule, MatInputModule, MatButtonModule, MatSortModule, MatSort, MatDialogModule, 
  MatNativeDateModule, MatDatepickerModule, MatListModule, MatIconModule, MatAutocompleteModule } from '@angular/material';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule, HTTP_INTERCEPTORS, HttpClient } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LoadingModule } from 'ngx-loading';
import { MatTabsModule } from '@angular/material';
import { MatTreeModule } from '@angular/material/tree';
import { MatSelectModule } from '@angular/material/select';
// import { EditorModule } from '@tinymce/tinymce-angular';
// import { NodeService } from './nodeservice'; 
// import { TreeTableModule } from 'primeng/treetable'; 

// Custom Providers 
import { ApplicationConstants } from '../providers/application-constants';
import { Utils } from '../providers/utils';
//import { TranslateModule , TranslateStaticLoader, TranslateLoader} from 'ng2-translate/ng2-translate';
import { LanguageService } from '../providers/language.service';
import { QueryList } from '../providers/query-list';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
// import { StorageServiceModule } from 'ngx-webstorage-service';

import { UserMainComponent } from './user-main/user-main.component';

//import { AppRoutingModule } from './app-routing.module';
import { MainAcctComponent } from './main-acct/main-acct.component';
import { ItemCatComponent } from './item-cat/item-cat.component';
import { ItemSubcatComponent } from './item-subcat/item-subcat.component';
import { SubItemComponent } from './sub-item/sub-item.component';
import { SubAcctComponent } from './sub-acct/sub-acct.component';
import { JournalEntryComponent } from './journal-entry/journal-entry.component';
import { JournalEntryListComponent } from './journal-entry-list/journal-entry-list.component';
import { ChartAcctsComponent } from './chart-accts/chart-accts.component';
import { SearchAcctsComponent } from './search-accts/search-accts.component';
import { SupplierCatListComponent } from './supplier-cat-list/supplier-cat-list.component';
import { SupplierCatComponent } from './supplier-cat/supplier-cat.component';
import { CustomerCatListComponent } from './customer-cat-list/customer-cat-list.component';
import { CustomerCatComponent } from './customer-cat/customer-cat.component';
import { TaxListComponent } from './tax-list/tax-list.component';
import { TaxComponent } from './tax/tax.component';
import { UnitListComponent } from './unit-list/unit-list.component';
import { UnitComponent } from './unit/unit.component';
import { CurrencyComponent } from './currency/currency.component';
import { CurrencyListComponent } from './currency-list/currency-list.component';
import { CostCenterComponent } from './cost-center/cost-center.component';
import { CostCenterListComponent } from './cost-center-list/cost-center-list.component';
import { CityComponent } from './city/city.component';
import { CountryComponent } from './country/country.component';
import { CityListComponent } from './city-list/city-list.component';
import { CountryListComponent } from './country-list/country-list.component';
import { CompanyListComponent } from './company-list/company-list.component';
import { CompanyComponent } from './company/company.component';
import { BranchListComponent } from './branch-list/branch-list.component';
import { BranchComponent } from './branch/branch.component';
import { ThermalPrinterListComponent } from './thermal-printer-list/thermal-printer-list.component';
import { ThermalPrinterComponent } from './thermal-printer/thermal-printer.component';
import { PaymentTypeComponent } from './payment-type/payment-type.component';
import { EmpAllowanceComponent } from './emp-allowance/emp-allowance.component';
import { EmpAllowanceListComponent } from './emp-allowance-list/emp-allowance-list.component';
import { InvCondListSearchComponent } from './inv-cond-list-search/inv-cond-list-search.component';
import { InvCondListComponent } from './inv-cond-list/inv-cond-list.component';
import { InvCondSearchComponent } from './inv-cond-search/inv-cond-search.component';
import { InvCondComponent } from './inv-cond/inv-cond.component';
import { CustomerListComponent } from './customer-list/customer-list.component';
import { CustomerComponent } from './customer/customer.component';
import { SubItemListComponent } from './sub-item-list/sub-item-list.component';
import { SubItemCatComponent } from './sub-item-cat/sub-item-cat.component';
import { EmployeeListComponent } from './employee-list/employee-list.component';
import { EmployeeComponent } from './employee/employee.component';
import { ItemCatListComponent } from './item-cat-list/item-cat-list.component';
import { ItemSubcatListComponent } from './item-subcat-list/item-subcat-list.component';
import { SubItemContentComponent } from './sub-item-content/sub-item-content.component';
import { SubMenuComponent } from './sub-menu/sub-menu.component';
import { SupplierListComponent } from './supplier-list/supplier-list.component';
import { SupplierComponent } from './supplier/supplier.component';
import { CustomerLimitComponent } from './customer-limit/customer-limit.component';
import { UserListComponent } from './user-list/user-list.component';
import { UserComponent } from './user/user.component';
import { SearchEmployeeComponent } from './search-employee/search-employee.component';
import { StoreListComponent } from './store-list/store-list.component';
import { StoreComponent } from './store/store.component';
import { DefInvCondListComponent } from './def-inv-cond-list/def-inv-cond-list.component';
import { FixedAssetListComponent } from './fixed-asset-list/fixed-asset-list.component';
import { FixedAssetComponent } from './fixed-asset/fixed-asset.component';
import { StockListComponent } from './stock-list/stock-list.component';
import { StockComponent } from './stock/stock.component';
import { SearchSubItemComponent } from './search-sub-item/search-sub-item.component';
import { BankAccountListComponent } from './bank-account-list/bank-account-list.component';
import { BankAccountComponent } from './bank-account/bank-account.component';
import { ReceiptListComponent } from './receipt-list/receipt-list.component';
import { ReceiptComponent } from './receipt/receipt.component';
import { EmployeeLoanListComponent } from './employee-loan-list/employee-loan-list.component';
import { EmployeeLoanComponent } from './employee-loan/employee-loan.component';
import { SalaryComponent } from './salary/salary.component';
import { EmpSalaryAllowComponent } from './emp-salary-allow/emp-salary-allow.component';
import { InvoiceComponent } from './invoice/invoice.component';
import { SearchCustomerComponent } from './search-customer/search-customer.component';
import { ViewAssetComponent } from './view-asset/view-asset.component';
import { SupplierInvoiceListComponent } from './supplier-invoice-list/supplier-invoice-list.component';
import { SupplierInvoiceComponent } from './supplier-invoice/supplier-invoice.component'; 
import { SearchSupplierComponent } from './search-supplier/search-supplier.component'; 
import { SuppInvPaymentMethodComponent } from './supp-inv-payment-method/supp-inv-payment-method.component';
import { SuppInvSearchSubitemComponent } from './supp-inv-search-subitem/supp-inv-search-subitem.component';
import { DepositComponent } from "./deposit/deposit.component";
import { DepositListComponent } from './deposit-list/deposit-list.component';
import { KeyboardComponent } from './keyboard/keyboard.component';
import { TrailBalanceComponent } from './trail-balance/trail-balance.component';
import { InvoiceListComponent } from './invoice-list/invoice-list.component';
import { QutationComponent } from './qutation/qutation.component';
import { QutationListComponent } from './qutation-list/qutation-list.component';
import { InvoiceItemComponent } from './invoice-item/invoice-item.component';
import { InvoiceDetailComponent } from './invoice-detail/invoice-detail.component';
import { TransferComponent } from './transfer/transfer.component';
import { TransferListComponent } from './transfer-list/transfer-list.component';
import { RepAcctComponent } from './rep-acct/rep-acct.component';
import { SupplierInvoiceReportComponent } from './supplier-invoice-report/supplier-invoice-report.component';
import { SupplierInvoiceDetailComponent } from './supplier-invoice-detail/supplier-invoice-detail.component';
//import { MainViewComponent } from './main-view/main-view.component';
//import { LoginComponent } from './login/login.component';
import { SearchComponent } from './search/search.component';
//import { PageNotFoundComponent } from './page-not-found/page-not-found.component'; 
import { ExpensesComponent } from './expenses/expenses.component';
import { ExpensesListComponent } from './expenses-list/expenses-list.component';
import { CustodySettlementComponent } from './custody-settlement/custody-settlement.component';
import { ReportComponent } from './report/report.component';
import { ProductionComponent } from './production/production.component';
import { ProductionListComponent } from './production-list/production-list.component';
import { StockReportComponent } from './stock-report/stock-report.component';
import { ReceiptDetailComponent } from './receipt-detail/receipt-detail.component';
import { BalanceListComponent } from './balance-list/balance-list.component';
import { ReturnInvoiceComponent } from './return-invoice/return-invoice.component';
import { ReturnInvoiceItemComponent } from './return-invoice-item/return-invoice-item.component';
import { SaleReportComponent } from './sale-report/sale-report.component';
import { ReturnTypeComponent } from './return-type/return-type.component';
import { TransportFeeComponent } from './transport-fee/transport-fee.component';
import { ReturnInvoiceListComponent } from './return-invoice-list/return-invoice-list.component';
import { StockTransferComponent } from './stock-transfer/stock-transfer.component';
import { UnpaidInvoiceComponent } from './unpaid-invoice/unpaid-invoice.component';
import { InvoiceItemDetailComponent } from './invoice-item-detail/invoice-item-detail.component';
import { CashAccountListComponent } from './cash-account-list/cash-account-list.component';
import { AllInvoiceComponent } from './all-invoice/all-invoice.component';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { TaxReportComponent } from './tax-report/tax-report.component';
import { TaxDetailComponent } from './tax-detail/tax-detail.component';
import { ReturnSupplierInvoiceComponent } from './return-supplier-invoice/return-supplier-invoice.component';
import { ReturnSupplierInvoiceItemComponent } from './return-supplier-invoice-item/return-supplier-invoice-item.component';
import { ExpensesReportComponent } from './expenses-report/expenses-report.component';
import { SubItemMoveReportComponent } from './sub-item-move-report/sub-item-move-report.component';
import { SubItemReportComponent } from './sub-item-report/sub-item-report.component';
import { SubItemIncomeReportComponent } from './sub-item-income-report/sub-item-income-report.component';
import { RepAcctReportComponent } from './rep-acct-report/rep-acct-report.component';
import { SupplierDebtReportComponent } from './supplier-debt-report/supplier-debt-report.component';
import { IncomeSummaryReportComponent } from './income-summary-report/income-summary-report.component';
import { PrepaidIncomeReportComponent } from './prepaid-income-report/prepaid-income-report.component';
import { PrepaidExpenseReportComponent } from './prepaid-expense-report/prepaid-expense-report.component';
import { OperationListComponent } from './operation-list/operation-list.component';
import { ReturnSupplierInvoiceListComponent } from './return-supplier-invoice-list/return-supplier-invoice-list.component';
import { StockDamageListComponent } from './stock-damage-list/stock-damage-list.component';
import { MaintRequestComponent } from './maint-request/maint-request.component';
import { RepairAppointmentComponent } from './repair-appointment/repair-appointment.component';
import { RepairAppointmentListComponent } from './repair-appointment-list/repair-appointment-list.component';
import { StockInventoryComponent } from './stock-inventory/stock-inventory.component';
import { CategoryListComponent } from './category-list/category-list.component';
import { CategoryComponent } from './category/category.component';
import { AirlineListComponent } from './airline-list/airline-list.component';
import { AirlineComponent } from './airline/airline.component';
import { AirportListComponent } from './airport-list/airport-list.component';
import { AirportComponent } from './airport/airport.component';
import { ClassListComponent } from './class-list/class-list.component';
import { ClassComponent } from './class/class.component';
import { BusListComponent } from './bus-list/bus-list.component';
import { BusComponent } from './bus/bus.component';
import { HotelListComponent } from './hotel-list/hotel-list.component';
import { HotelComponent } from './hotel/hotel.component';
import { RoomTypeListComponent } from './room-type-list/room-type-list.component';
import { RoomTypeComponent } from './room-type/room-type.component';
import { StaffListComponent } from './staff-list/staff-list.component';
import { StaffComponent } from './staff/staff.component';
import { ProfileComponent } from './profile/profile.component';
import { IncomeReportComponent } from './income-report/income-report.component';
import { InvoiceDesignComponent } from './invoice-design/invoice-design.component';
import { InvoiceDesignListComponent } from './invoice-design-list/invoice-design-list.component';
import { SalePointComponent } from './sale-point/sale-point.component';
import { OrderTypeComponent } from './order-type/order-type.component';
import { ChooseTableComponent } from './choose-table/choose-table.component';
import { OrderCommentComponent } from './order-comment/order-comment.component';
import { ServTableComponent } from './serv-table/serv-table.component';
import { ServTableListComponent } from './serv-table-list/serv-table-list.component';
import { FlavourListComponent } from './flavour-list/flavour-list.component';
import { FlavourComponent } from './flavour/flavour.component';
import { ExpensesIncomeReportComponent } from './expenses-income-report/expenses-income-report.component';
import { RequestListComponent } from './request-list/request-list.component';
import { PosSessionOpenComponent } from './pos-session-open/pos-session-open.component';
import { PosSessionCloseComponent } from './pos-session-close/pos-session-close.component';
import { PosSessionListComponent } from './pos-session-list/pos-session-list.component';
import { PosSessionDetailComponent } from './pos-session-detail/pos-session-detail.component';
import { CashPaymentComponent } from './cash-payment/cash-payment.component';
import { PurchaseOrderComponent } from './purchase-order/purchase-order.component';
import { PurchaseOrderListComponent } from './purchase-order-list/purchase-order-list.component';
import { ReceiptStatementComponent } from './receipt-statement/receipt-statement.component';
import { StatementListComponent } from './statement-list/statement-list.component';
import { BranchAuthComponent } from './branch-auth/branch-auth.component';
import { BranchSelectComponent } from './branch-select/branch-select.component';
import { TourProgComponent } from './tour-prog/tour-prog.component';
import { TravelerListComponent } from './traveler-list/traveler-list.component';
import { TravelerComponent } from './traveler/traveler.component';
import { TourProgListComponent } from './tour-prog-list/tour-prog-list.component';
import { RegOnTripComponent } from './reg-on-trip/reg-on-trip.component';
import { AccountListComponent } from './account-list/account-list.component';
import { TravelerCheckComponent } from './traveler-check/traveler-check.component';
import { TripTravelerListComponent } from './trip-traveler-list/trip-traveler-list.component';
import { TourInvoiceListComponent } from './tour-invoice-list/tour-invoice-list.component';
import { SearchListComponent } from './search-list/search-list.component';
import { RegOnTripReportComponent } from './reg-on-trip-report/reg-on-trip-report.component';
import { TicketReportComponent } from './ticket-report/ticket-report.component';
import { BusReportComponent } from './bus-report/bus-report.component';
import { StoreSelectComponent } from './store-select/store-select.component';
import { SimpleReceiptComponent } from './simple-receipt/simple-receipt.component';
import { RoomReportComponent } from './room-report/room-report.component';
import { DeliveryReportComponent } from './delivery-report/delivery-report.component';
import { InvoiceItemCommentComponent } from './invoice-item-comment/invoice-item-comment.component';
import { ReceiptReportComponent } from './receipt-report/receipt-report.component';
import { SpecialProgramComponent } from './special-program/special-program.component';
import { StockTransferListComponent } from './stock-transfer-list/stock-transfer-list.component';
import { VisaReportComponent } from './visa-report/visa-report.component';
// import { StockBalanceListComponent } from './stock-balance-list/stock-balance-list.component';
import { StockBaseComponent } from './stock-base/stock-base.component';
import { StockFilterComponent } from './stock-filter/stock-filter.component';
import { CommercialInvoiceComponent } from './commercial-invoice/commercial-invoice.component';
import { CommercialInvoicePrintComponent } from './commercial-invoice-print/commercial-invoice-print.component';
import { OverallReportComponent } from './overall-report/overall-report.component';
import { ColumnSelectComponent } from './column-select/column-select.component';
import { ChangeProgComponent } from './change-prog/change-prog.component';
import { TourProgRepComponent } from './tour-prog-rep/tour-prog-rep.component';
import { PreregisterListComponent } from './preregister-list/preregister-list.component';
import { StockMoveReportComponent } from './stock-move-report/stock-move-report.component';
import { SendMsgComponent } from './send-msg/send-msg.component';
import { FlightComponent } from './flight/flight.component';
import { FlightListComponent } from './flight-list/flight-list.component';
import { RegOnFlightComponent } from './reg-on-flight/reg-on-flight.component';
import { AgentListComponent } from './agent-list/agent-list.component';
import { AgentComponent } from './agent/agent.component';
import { RegOnBlockComponent } from './reg-on-block/reg-on-block.component';
import { ChangeCcComponent } from './change-cc/change-cc.component';
import { FlightTicketReportComponent } from './flight-ticket-report/flight-ticket-report.component';
import { FinPositionComponent } from './fin-position/fin-position.component';
import { FlightCustomizeComponent } from './flight-customize/flight-customize.component';
import { ReturnAllDateComponent } from './return-all-date/return-all-date.component';
import { DailyRegComponent } from './daily-reg/daily-reg.component';
import { HousingReportComponent } from './housing-report/housing-report.component';
import { AgentUserComponent } from './agent-user/agent-user.component';
import { ZatcaInvoiceListComponent } from './zatca-invoice-list/zatca-invoice-list.component';
import { InvoiceBackupComponent } from './invoice-backup/invoice-backup.component';


// AoT requires an exported function for factories
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
  declarations: [
    UserMainComponent,
    MainAcctComponent,
    ItemCatComponent,
    ItemSubcatComponent,
    SubItemComponent,
    SubAcctComponent,
    JournalEntryComponent,
    JournalEntryListComponent,
    ChartAcctsComponent,
    SearchAcctsComponent,
    SupplierCatListComponent,
    SupplierCatComponent,
    CustomerCatListComponent,
    CustomerCatComponent,
    TaxListComponent,
    TaxComponent,
    UnitListComponent,
    UnitComponent,
    CurrencyComponent,
    CurrencyListComponent,
    CostCenterComponent,
    CostCenterListComponent,
    CityComponent,
    CountryComponent,
    CityListComponent,
    CountryListComponent,
    CompanyListComponent,
    CompanyComponent,
    BranchListComponent,
    BranchComponent,
    ThermalPrinterListComponent,
    ThermalPrinterComponent,
    PaymentTypeComponent,
    EmpAllowanceComponent,
    EmpAllowanceListComponent,
    InvCondListSearchComponent,
    InvCondListComponent,
    InvCondSearchComponent,
    InvCondComponent,
    CustomerListComponent,
    CustomerComponent,
    SubItemListComponent,
    SubItemCatComponent,
    EmployeeListComponent,
    EmployeeComponent,
    ItemCatListComponent,
    ItemSubcatListComponent,
    SubItemContentComponent,
    SubMenuComponent,
    SupplierListComponent,
    SupplierComponent,
    CustomerLimitComponent,
    UserListComponent,
    UserComponent,
    SearchEmployeeComponent,
    StoreListComponent,
    StoreComponent, 
    DefInvCondListComponent,
    FixedAssetListComponent,
    FixedAssetComponent,
    StockListComponent,
    StockComponent,
    SearchSubItemComponent,
    BankAccountListComponent,
    BankAccountComponent,
    ReceiptListComponent, 
    ReceiptComponent,
    EmployeeLoanListComponent,
    EmployeeLoanComponent,
    SalaryComponent,
    EmpSalaryAllowComponent,
    InvoiceComponent,
    SearchCustomerComponent,
    ViewAssetComponent,
    SupplierInvoiceListComponent,
    SupplierInvoiceComponent,
    SuppInvPaymentMethodComponent,
    SearchSupplierComponent,
    SuppInvSearchSubitemComponent,
    DepositComponent,
    DepositListComponent,
    KeyboardComponent,
    TrailBalanceComponent,
    InvoiceListComponent,
    QutationComponent,
    QutationListComponent,
    InvoiceItemComponent,
    InvoiceDetailComponent,
    TransferComponent,
    TransferListComponent,
    RepAcctComponent,
    SupplierInvoiceReportComponent,
    SupplierInvoiceDetailComponent,
    //MainViewComponent,
    SearchComponent,
    ExpensesComponent,
    ExpensesListComponent,
    CustodySettlementComponent,
    ReportComponent,
    ProductionComponent,
    ProductionListComponent,
    StockReportComponent,
    ReceiptDetailComponent,
    BalanceListComponent,
    ReturnInvoiceComponent,
    ReturnInvoiceItemComponent,
    SaleReportComponent,
    ReturnTypeComponent,
    TransportFeeComponent,
    ReturnInvoiceListComponent,
    StockTransferComponent,
    UnpaidInvoiceComponent,
    InvoiceItemDetailComponent,
    CashAccountListComponent,
    AllInvoiceComponent,
    ChangePasswordComponent,
    TaxReportComponent,
    TaxDetailComponent,
    ReturnSupplierInvoiceComponent,
    ReturnSupplierInvoiceItemComponent,
    ExpensesReportComponent,
    SubItemMoveReportComponent,
    SubItemReportComponent,
    SubItemIncomeReportComponent,
    RepAcctReportComponent,
    SupplierDebtReportComponent,
    IncomeSummaryReportComponent,
    PrepaidIncomeReportComponent,
    PrepaidExpenseReportComponent,
    OperationListComponent,
    ReturnSupplierInvoiceListComponent,
    StockDamageListComponent,
    MaintRequestComponent,
    RepairAppointmentComponent,
    RepairAppointmentListComponent,
    StockInventoryComponent,
    CategoryListComponent,
    CategoryComponent,
    AirlineListComponent,
    AirlineComponent,
    AirportListComponent,
    AirportComponent,
    ClassListComponent,
    ClassComponent,
    BusListComponent,
    BusComponent,
    HotelListComponent,
    HotelComponent,
    RoomTypeListComponent,
    RoomTypeComponent,
    StaffListComponent,
    StaffComponent,
    ProfileComponent,
    IncomeReportComponent,
    InvoiceDesignComponent,
    InvoiceDesignListComponent,
    SalePointComponent,
    OrderTypeComponent,
    ChooseTableComponent,
    OrderCommentComponent,
    ServTableComponent,
    ServTableListComponent,
    FlavourListComponent,
    FlavourComponent,
    ExpensesIncomeReportComponent,
    RequestListComponent,
    PosSessionOpenComponent,
    PosSessionCloseComponent,
    PosSessionListComponent,
    PosSessionDetailComponent,
    CashPaymentComponent,
    PurchaseOrderComponent,
    PurchaseOrderListComponent,
    ReceiptStatementComponent,
    StatementListComponent,
    BranchAuthComponent,
    BranchSelectComponent,
    TourProgComponent,
    TravelerListComponent,
    TravelerComponent,
    TourProgListComponent,
    RegOnTripComponent,
    AccountListComponent,
    TravelerCheckComponent,
    TripTravelerListComponent,
    TourInvoiceListComponent,
    SearchListComponent,
    RegOnTripReportComponent,
    TicketReportComponent,
    BusReportComponent,
    StoreSelectComponent,
    SimpleReceiptComponent,
    RoomReportComponent,
    DeliveryReportComponent,
    InvoiceItemCommentComponent,
    ReceiptReportComponent,
    SpecialProgramComponent,
    StockTransferListComponent,
    VisaReportComponent,
    // StockBalanceListComponent,
    StockBaseComponent,
    StockFilterComponent,
    CommercialInvoiceComponent,
    CommercialInvoicePrintComponent,
    OverallReportComponent,
    ColumnSelectComponent,
    ChangeProgComponent,
    TourProgRepComponent,
    PreregisterListComponent,
    StockMoveReportComponent,
    SendMsgComponent,
    FlightComponent,
    FlightListComponent,
    RegOnFlightComponent,
    AgentListComponent,
    AgentComponent,
    RegOnBlockComponent,
    ChangeCcComponent,
    FlightTicketReportComponent,
    FinPositionComponent,
    FlightCustomizeComponent,
    ReturnAllDateComponent,
    DailyRegComponent,
    HousingReportComponent,
    AgentUserComponent,
    ZatcaInvoiceListComponent,
    InvoiceBackupComponent
    //PageNotFoundComponent
  ],
  imports: [
    UserViewRoutingModule,
    BrowserModule,
    MatTableModule,
    MatSortModule,
    MatListModule, 
    BrowserAnimationsModule,
    HttpClientModule,
    MatDialogModule,
    FormsModule,
    MatNativeDateModule,
    MatDatepickerModule,
    MatIconModule,
    LoadingModule,
    MatAutocompleteModule,
    MatExpansionModule,
    MatToolbarModule,
    MatSidenavModule,
    ReactiveFormsModule,
    MatTabsModule,
    MatTreeModule,
    MatSelectModule,
    // EditorModule,
    HttpClientModule,
    // TreeTableModule,
    TranslateModule.forRoot({
        loader: {
            provide: TranslateLoader,
            useFactory: HttpLoaderFactory,
            deps: [HttpClient]
        }
    }),
    // StorageServiceModule
    
    // TreeTableModule,
    // TranslateModule.forRoot({
    //   provide: TranslateLoader,
    //   useFactory: (createTranslateLoader),
    //   deps: [Http]
    // })
  ],
  entryComponents:[SearchAcctsComponent, ItemCatComponent, SubItemComponent, SubItemContentComponent, 
    SearchEmployeeComponent, SearchSubItemComponent, SearchSupplierComponent, SearchCustomerComponent, 
    JournalEntryComponent, SuppInvSearchSubitemComponent, SuppInvPaymentMethodComponent, TransferComponent, 
    DepositComponent, SupplierInvoiceReportComponent, SupplierInvoiceDetailComponent, RepAcctComponent, 
    ExpensesComponent, CustomerLimitComponent, ReturnTypeComponent, TransportFeeComponent, 
    StockTransferComponent, ChangePasswordComponent, CashPaymentComponent, CustomerComponent, 
    TravelerComponent, AgentComponent, ChangeCcComponent, ReturnAllDateComponent, HousingReportComponent, 
    AgentUserComponent]
})
export class UserViewModule { }
